import React from "react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const CraftFilterItemScrollable = ({
  sortedItems,
  isActiveFilter,
  activeFiltersHandle,
  clearFilter,
}) => {
  return (
    <section className="gradient-block__search-popup">
      <Swiper
        direction={"vertical"}
        slidesPerView={"auto"}
        freeMode={true}
        mousewheel={{
        releaseOnEdges: true
      }}
        scrollbar={{
          draggable: true,
          snapOnRelease: false
        }}
        modules={[FreeMode, Mousewheel, Scrollbar]}
        className="gradient-block__search-popup-slider"
      >
        <SwiperSlide>
          <div className="gradient-block__search-popup-actions">
            {sortedItems.map((item) => (
              <button
                className={`gradient-block__search-popup-action ${isActiveFilter(
                  item.value
                )}`}
                type="button"
                key={item.name}
                onClick={() => activeFiltersHandle(item.value)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </SwiperSlide>
      </Swiper>
      <button
        className="main-content__filters-dropdown-clear"
        type="button"
        onClick={clearFilter}
      >
        Clear all
      </button>
    </section>
  );
};

export default CraftFilterItemScrollable;
